import React from 'react';

export const Ai_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>AI ARTISTS</span>,
  },
];

export const DavidC_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>ARQUITECTO VISUAL NEURAL</span>,
  },
];

export const DavidC_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Editor veterano con más de 20 años en producción televisiva. Hoy integra
        AI generativa en pipelines reales con consistencia visual y estándar
        cinematográfico. Sin excusas. Solo resultados.
      </span>
    ),
  },
];

export const DavidC_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>THE LAST CASE: An AI Noir Film.</span>,
  },
];

export const DavidC_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Choose Your Role</span>,
  },
];

export const DavidC_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>BUNNYNJA</span>,
  },
];

export const AndresB_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>CINEASTA DE NARRATIVAS HÍBRIDAS</span>,
  },
];

export const AndresB_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Director y productor entre ficción, documental y narrativa AI. Con base
        en Barcelona, combina rodaje clásico con exploración técnica avanzada,
        siempre al servicio de historias humanas. Versátil, autoral y preciso.
      </span>
    ),
  },
];

export const AndresB_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>ZOMBIE PATROL</span>,
  },
];

export const AndresB_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>TIMELINE. (A.I. Shortfilm)</span>,
  },
];

export const AndresB_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>MODE. (A.I. Shortfilm)</span>,
  },
];

export const AlvaroC_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>DISEÑADOR DE FLUJOS GENERATIVOS</span>,
  },
];

export const AlvaroC_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Editor con más de 10 años de experiencia, enfocado en ritmo, emoción y
        narrativa. Hoy integra AI generativa en workflows híbridos para expandir
        lo posible sin perder control editorial. Precisión, detalle y
        colaboración.
      </span>
    ),
  },
];

export const AlvaroC_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>ATHLA</span>,
  },
];

export const AlvaroC_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>FREE</span>,
  },
];

export const AlvaroC_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>GHOST MEMORY</span>,
  },
];

export const Robot_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>ORQUESTADORES DE CRAFT E INDUSTRIA</span>,
  },
];

export const Robot_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Dupla de directores con ADN de set y publicidad. Craft, ritmo y puesta
        en escena como base, con AI integrada como herramienta narrativa.
        <br />
        <br />
        Producciones híbridas con control autoral y solidez visual.
      </span>
    ),
  },
];

export const Robot_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>La nombramos Perú - VEO 3</span>,
  },
];

export const Robot_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Adidas</span>,
  },
];

export const Robot_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Ad Monster</span>,
  },
];

export const DavidN_Title = [
  {
    textSize: '2.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '400',
    textType: 'p',
    renderContent: () => <span>INGENIERO DE NARRATIVAS SINTÉTICAS</span>,
  },
];

export const DavidN_Text = [
  {
    textSize: '1.25rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => (
      <span>
        Director y postproductor con 13 años en Buenos Aires y experiencia con
        Warner, Disney y Viacom. Hoy crea narrativas híbridas con AI generativa
        y experiencias interactivas, usando la tecnología como motor creativo
        sin perder dirección ni storytelling.
      </span>
    ),
  },
];

export const DavidN_Video1 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>Chanel 11.12 - Concept</span>,
  },
];

export const DavidN_Video2 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>PLUTOCRACIA</span>,
  },
];

export const DavidN_Video3 = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'p',
    renderContent: () => <span>DÍA DE MUERTOS</span>,
  },
];
